import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import Breadcrumbs from 'components/@extended/Breadcrumbs';
import UpgradePlanDialog from 'components/UpgradePlanDialog';
import PageTour from 'components/PageTour';
import { useSubscription } from 'features/subscription/useSubscription';
import { TourProvider } from 'contexts/TourContext';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));
  const [showUpgradeDialog, setShowUpgradeDialog] = useState(false);
  const { isFree, freeLimitExceeded } = useSubscription();

  useEffect(() => {
    if (isFree && freeLimitExceeded) {
      setShowUpgradeDialog(true);
    }
  }, [isFree, freeLimitExceeded]);

  // set media wise responsive drawer
  // useEffect(() => {
  //   handlerDrawerOpen(!downXL);
  // }, [downXL]);

  if (menuMasterLoading) return <Loader />;

   
return (
    <TourProvider>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Header />
        <Drawer />

        <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 2, sm: 3 } }}>
          <Toolbar sx={{ mt: 'inherit' }} />
          <Box
            sx={{
              ...{ px: { xs: 0, sm: 2 } },
              position: 'relative',
              minHeight: 'calc(100vh - 110px)',
              display: 'flex',
              flexDirection: 'column'
            }}
          >
            {/* <Breadcrumbs /> */}
            <Outlet />
            {/* <Footer /> */}
          </Box>
        </Box>

        <UpgradePlanDialog
          open={showUpgradeDialog}
          onClose={() => setShowUpgradeDialog(false)}
          reason="limit"
        />
        <PageTour />
      </Box>
    </TourProvider>
  );
}
